var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVentilation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.83 7.77195C11.4396 6.38325 11.8061 5.02435 11.9302 3.69614C12.116 2.22437 11.2868 1 9.00018 1C6.71355 1 5.88435 2.22527 6.07012 3.69614C6.19424 5.02435 6.56071 6.38325 7.17037 7.77195M9.98739 13.4171C10.8065 14.6766 11.7243 15.6951 12.7376 16.4744C13.8353 17.3827 15.2429 17.2265 16.3862 15.1091C17.5295 12.9918 16.952 11.6112 15.6685 11.0478C14.5302 10.4988 13.2468 10.1584 11.8164 10.0293M6.18356 10.0293C4.75399 10.1584 3.47051 10.4988 2.33311 11.0478C1.04793 11.6103 0.470365 12.9918 1.61368 15.1091C2.75699 17.2265 4.16376 17.3818 5.26232 16.4744C6.2756 15.6951 7.19346 14.6766 8.01337 13.4171M11.5335 10.0293C11.5335 11.5253 10.3994 12.7381 9.00034 12.7381C7.60129 12.7381 6.46714 11.5253 6.46714 10.0293C6.46714 8.53325 7.60129 7.32049 9.00034 7.32049C10.3994 7.32049 11.5335 8.53325 11.5335 10.0293Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilation);
export default __webpack_public_path__ + "static/media/Ventilation.b8ec13eabcafbf5d5bf7383aa2c60bcc.svg";
export { ForwardRef as ReactComponent };